import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';

@Component({
	selector: 'app-currency',
	templateUrl: './currency.component.html',
	styleUrls: ['./currency.component.css'],
})
export class CurrencyComponent extends ShowComponent {
	protected apiType = 'bag';
	protected apiUrlAdd = '/currency/';
	protected parentComponent = 'codebook/currency';
	parentLocationSet = [];
	currencys = [];
	codebook;
	protected itemsBeforeDataLoad = 2;
	protected pageTitleGenerate(): string {
		return `Słowniki ->
			${this.codebook.name}
			->
			${this.data.name}
			(ID:
			${this.data.id}
			)`;
	}

	data = {
		id: null,
		name: null,
		code: null,
		exchangeRatePln: null,
	};

	protected loadBefore(): void {
		this.bag.get('/codebook/14/', (result, error) => {
			this.codebook = result;

			this.loadData();
		});
		this.bag.get('/currency/?limit=9999', (result, error) => {
			this.currencys = result.results;
			this.loadData();
		});
	}

	protected convertData(data: any) {
		data.exchangeRatePln = data.exchangeRatePln / 100;
		return data;
	}

	protected changeDecimal() {
		this.data.exchangeRatePln = this.data.exchangeRatePln.toFixed(2);
	}

	protected submitBefore(): void {
		this.data.exchangeRatePln = (parseFloat(this.data.exchangeRatePln) * 100).toFixed(0);
	}

	protected submitAfter(): void {
		this.data.exchangeRatePln = this.data.exchangeRatePln / 100;
		this.router.navigate([this.parentComponent]);
	}

	protected getApiUrl(): string {
		return '/currency/' + this.data.id + '/';
	}
	protected checkAndSubmit() {
		const currencyCheck = this.currencys.find(
			(item) =>
				item.name == this.data.name &&
				item.exchangeRatePln == parseFloat(this.data.exchangeRatePln) * 100 &&
				item.code == this.data.code,
		);
		if (currencyCheck != undefined) {
			this.infobox.error('Waluta o podanych danych już istnieje!');
			return;
		}
		this.submit();
	}
}
